import { OIDCConfig, Session } from '@/model';
import api from '@/rest-api';
import moduleBuilder from '@/store/module-builder';
import store from '@/store/store';
import Keycloak from 'keycloak-js';

export type AuthState = 'pending' | 'authorized' | 'unauthorized'

const authModule = moduleBuilder()
  .state({
    state: 'pending' as AuthState,
    session: undefined as undefined | Session,
  })
  .mutations({
    authorized(state, session: Session) {
      state.state = 'authorized';
      state.session = session;
    },
    unauthorized(state) {
      state.state = 'unauthorized';
      state.session = undefined;
    },
  })
  .actions({
    async loadSession(ctx) {
      try {
        const session = await api.session();
        ctx.commit('authorized', session);
      } catch (e) {
        ctx.dispatch('federate');
      }
    },
    async federate(ctx) {
      try {
        const config: OIDCConfig = await api.oidcConfig();
        const kc = new Keycloak(config);
        const authenticated = await kc.init({ pkceMethod: 'S256', checkLoginIframe: false });
        if (authenticated) {
          if (kc.hasResourceRole(config.requiredRole)) {
            await api.login(kc.token as string);
            const session = await api.session();
            ctx.commit('authorized', session);
          } else {
            // eslint-disable-next-line no-console
            console.log(`Missing required role ${config.requiredRole}`);
            ctx.commit('unauthorized');
          }
        } else {
          ctx.commit('unauthorized');
          await kc.login({ idpHint: config.idpHint });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        ctx.commit('unauthorized');
      }
    },
  })
  .hideMutations()
  .register(store, 'auth');

export default authModule;
